import React, { useState } from 'react'
import DashboardLayout from '../../components/layouts/dashboard'
import TabView from '../../components/tabview'
import AllNotifications from '../../components/notifications/all-notifications'
import BirthdayNotifications from '../../components/notifications/birthday-notifications'

const NotificationPage = () => {
  const [activeTab, setActiveTab] = useState(1)

  const NotificationTabs = [
    {
      title: 'All Notifications',
      Content: AllNotifications,
    },
    {
      title: 'Birthday Notifications',
      Content: BirthdayNotifications,
    },
  ]

  return (
    <DashboardLayout title='Notifications'>
      <div className='font-bold text-lg mb-3 text-hr-primary-1'>
        Notifications
      </div>
      <div className='mt-2'>
        <TabView
          Tabs={NotificationTabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>
    </DashboardLayout>
  )
}

export default NotificationPage
